import { render, staticRenderFns } from "./NbDocumentInput.vue?vue&type=template&id=472fb744&"
import script from "./NbDocumentInput.vue?vue&type=script&lang=js&"
export * from "./NbDocumentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports